import React, { useEffect } from 'react';
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent
} from '@mui/material';
import { useRecoilState } from 'recoil';
import { CustomTypography } from 'shared/ui/CustomTypography';
import { appNameState } from 'features/optimization/state/appConfigAtoms';

interface Props {
  label: string;
  labelXs?: number;
  fieldXs?: number;
}

export const NameSelector: React.FC<Props> = ({
  label,
  labelXs = 5,
  fieldXs = 3,
}) => {
  const [appName, setAppName] = useRecoilState(appNameState);

  const presetOptions = [
    'cd_0deg',
    'cd_0deg-cd_4deg',
    'cd_0deg-delta_cd_4deg',
    'cd_0deg-cl_0deg'
  ] as const;
  const normalizedAppName =
    presetOptions.includes(appName as typeof presetOptions[number])
      ? appName
      : presetOptions[0];

  useEffect(() => {
    if (normalizedAppName !== appName) {
      setAppName(normalizedAppName);
    }
  }, [appName, normalizedAppName, setAppName]);

  return (
    <Box component="div" sx={{ paddingTop: 1 }}>
      <Grid container alignItems="center" spacing={0.5}>
        <Grid item xs={labelXs}>
          <CustomTypography>
            {label}
          </CustomTypography>
        </Grid>
        <Grid item xs={fieldXs}>
          <FormControl
            size="small"
            sx={{
              width: '100%',
              backgroundColor: '#404040',
              borderRadius: 1,
            }}
          >
            <InputLabel
              id="app-name-select-label"
              sx={{
                color: '#f0f0f0',
                fontSize: '12px',
              }}
            >
              select objective
            </InputLabel>
            <Select
              labelId="app-name-select-label"
              value={normalizedAppName}
              label="select objective"
              onChange={(e: SelectChangeEvent<string>) => setAppName(e.target.value)}
              size="small"
              sx={{
                color: '#f0f0f0',
                fontSize: '12px',
                '.MuiSvgIcon-root': { color: '#f0f0f0' },
              }}
            >
              <MenuItem value="cd_0deg">直進Cd</MenuItem>
              <MenuItem value="cd_0deg-cd_4deg">直進Cd &amp; 4°Cd</MenuItem>
              <MenuItem value="cd_0deg-delta_cd_4deg">直進Cd &amp; Δ4°Cd</MenuItem>
              <MenuItem value="cd_0deg-cl_0deg">直進Cd &amp; 直進Cl</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
};
